import { MutableRefObject } from "react";
import { useStats } from "react-instantsearch-core-v7";
import { MessageDescriptor } from "@lingui/core";
import { ArrowLeft } from "src/organisms/AlgoliaProductList/MobileFilterView/DrawerFilter/DrawerFilter.styled";
import {
  MobileClearAllButton,
  MobileFilterContainer,
} from "./MobileFilter.styled";
import { LabelNavigation } from "../LabelNavigation";
import classNames from "classnames";
import { ResultsButton } from "src/organisms/AlgoliaProductList/DesktopFilterVeiw/DesktopFilter.styled";
import { Trans } from "@lingui/macro";
import { CategoryTree } from "../CategoryTree";
import { PLPTypes } from "src/types/PLPType.d";

type MobileCategoryFilterProps = {
  title: MessageDescriptor;
  isOpen: boolean;
  isMultiColumn?: boolean;
  categoryPageId?: string;
  gender: string;
  pageContentType: PLPTypes;
  hasFilters: boolean;
  toggleOpen: () => void;
  onClear: () => void;
  gridRef: MutableRefObject<HTMLDivElement | null>;
};

function MobileCategoryFilter({
  categoryPageId,
  gender,
  isOpen,
  title,
  pageContentType,
  hasFilters,
  gridRef,
  toggleOpen,
  onClear,
}: MobileCategoryFilterProps): JSX.Element {
  const { nbHits: total } = useStats();

  return (
    <MobileFilterContainer className={classNames({ ["open"]: isOpen })}>
      <LabelNavigation
        label={title}
        leftAdornment={
          <MobileClearAllButton className="no-padding" onClick={toggleOpen}>
            <ArrowLeft strokeWidth="2" />
          </MobileClearAllButton>
        }
        rightAdornment={
          hasFilters ? (
            <MobileClearAllButton onClick={onClear}>
              <Trans>Clear all</Trans>
            </MobileClearAllButton>
          ) : undefined
        }
      />
      <div className="content-wrapper">
        <CategoryTree
          gender={gender}
          categoryPageId={categoryPageId}
          pageContentType={pageContentType}
          gridRef={gridRef}
        />

        <ResultsButton
          fullWidth
          variant="primary"
          onClick={toggleOpen}
          disabled={total <= 0}
          className="total-button"
        >
          <span>
            {total > 0 ? (
              <Trans>Show {total} results</Trans>
            ) : (
              <Trans>Close</Trans>
            )}
          </span>
        </ResultsButton>
      </div>
    </MobileFilterContainer>
  );
}

export { MobileCategoryFilter };
